import axios from 'axios'
import { AuthModel, OauthLinkModel, UserModel } from './_models'

export const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/getuser`
export const UPDATE_USER_URL = `${API_URL}/auth/updateuser`
export const LOGIN_URL = `${API_URL}/auth/signin`
export const REGISTER_URL = `${API_URL}/auth/signup`
export const REFRESH_URL = `${API_URL}/auth/refresh`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

export const OAUTH_GETLINK = `${API_URL}/auth/oauth_link`
export const OAUTH_GETOKEN = `${API_URL}/auth/oauth_token`

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    username,
    password,
  })
}

// Server should return AuthModel
export async function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  const s = await axios.post(REGISTER_URL, {
    username: email,
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
  return axios.post<AuthModel>(LOGIN_URL, {
    username: email,
    password: password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}


export function getOauthLink(provider: string) {
  return axios.get<OauthLinkModel>(OAUTH_GETLINK, {
    params: {
      provider: provider
    }
  })
}

export function LoginWithOauthCode(code: string) {
  return axios.get<AuthModel>(OAUTH_GETOKEN, {
    params: {
      code: code
    }
  })
}

export function updateUser(user: UserModel) {
  return axios.post<UserModel>(UPDATE_USER_URL, user)
}


